// Ring-group strategy options. `icon` (MaterialCommunity name) and `tone`
// (theme color key) drive the per-strategy accent in NtStrategyHint.
const ringgroupstrategytypesdata = [
  {
    id: "enterprise",
    title: "Enterprise",
    icon: "lightning-bolt",
    tone: "brand2",
    description:
      "Ring all destinations at the same time, ignoring per-destination delays. First to answer takes the call.",
  },
  {
    id: "simultaneous",
    title: "Simultaneous",
    icon: "bell-ring-outline",
    tone: "teal",
    description:
      "Ring all destinations at the same time, but respect each destination's delay so they can be staggered.",
  },
  {
    id: "sequence",
    title: "Sequence",
    icon: "format-list-numbered",
    tone: "green",
    description:
      "Ring destinations one at a time in the order listed. Each gets its full timeout before moving to the next.",
  },
  {
    id: "rollover",
    title: "Rollover",
    icon: "arrow-decision-outline",
    tone: "orange",
    description:
      "Ring destinations one at a time in order. The group's overall call-timeout is shared across them.",
  },
  {
    id: "random",
    title: "Random",
    icon: "shuffle-variant",
    tone: "yellow",
    description:
      "Ring destinations one at a time in random order until someone answers.",
  },
];

export default ringgroupstrategytypesdata;
